import { Loader2, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { useDeleteHourlyTuitionBilling } from '~entities/payment/api/hourly-tuition/delete-hourly-tuition-billing';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '~shared/shadcn/ui/alert-dialog';
import { Button } from '~shared/shadcn/ui/button';

export function DeleteAlertDialog({ billingId }: { billingId: string }) {
  const { mutateAsync: deleteHourlyTuitionBilling, isPending } =
    useDeleteHourlyTuitionBilling();
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteHourlyTuitionBilling({ id: billingId });
      toast.success('The billing plan was successfully deleted.');
      setOpen(false);
    } catch (error) {
      console.error('Error deleting billing plan:', error);
      toast.error('Failed to delete the billing plan. Please try again.');
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Trash2 className='size-4 cursor-pointer text-red-700 hover:text-red-900' />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Billing Plan</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <Button
            onClick={handleDelete}
            disabled={isPending}
            className='bg-red-600 text-white hover:bg-red-700 disabled:opacity-50'
          >
            {isPending ? (
              <>
                <Loader2 className='size-4 animate-spin' />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
